import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { XCircleIcon } from "@heroicons/react/24/outline"

const FailStatus = () => {
    const [message] = useState('Order Placement Failed');

    useEffect(() => {
        // Call the API to save the payment status when the component is mounted
    }, []);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-red-500 to-pink-600 text-white p-6">
            <div className="bg-white text-gray-800 rounded-2xl shadow-xl p-8 max-w-lg w-full text-center transform transition-all duration-300 ease-in-out hover:scale-105">
                <XCircleIcon className="w-20 h-20 text-red-500 mx-auto mb-4" />
                <h2 className="text-2xl font-bold mb-4">{message}</h2>
                <p className="text-gray-600 mb-6 text-lg">
                    Unfortunately, we were unable to process your order due to a payment issue.
                    Please check your payment details and try again. If the problem persists, contact our support team for assistance.
                </p>
                <Link to="/" state={{ message: "Return to shopping and try again." }}>
                    <button className="px-6 py-3 bg-gradient-to-r from-red-500 to-pink-600 text-white font-semibold rounded-lg shadow-md hover:from-red-600 hover:to-pink-700 transition-all duration-300">
                        Try Again
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default FailStatus;
